<template>
  <v-dialog v-model="visible" width="800">
    <v-card class="not-margin pt-0 pr-0 pl-0">
      <v-toolbar dark color="primary">
        <div class="text-center">
          <v-icon>mdi-eye</v-icon> Adicionar um novo tipo de termo
        </div>
      </v-toolbar>
      <div class="container dialog">
        <v-row class="d-flex justify-center mt-7">
          <v-col cols="12">
            <v-text-field
              v-model="novoTipoTermo"
              label="Tipo de Termo*"
              outlined
              dense
              :rules="[(v) => v && v.length > 0 || 'Campo obrigatório']"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <sigfoco-buttons
      @click="confirmar"
      @cancel="cancelar" 
      :actionText="'Confirmar'"
    ></sigfoco-buttons>
    </v-card>
  </v-dialog>
</template>
  
<script>
  export default {
    props: {
      visible: Boolean,
    },
    data() {
      return {
        novoTipoTermo: '',
      };
    },
    methods: {
      cancelar() {
        this.$emit("update:visible", false);
      },
      confirmar() {
        if (this.novoTipoTermo) {
          this.$emit("confirmarNovoTipo", this.novoTipoTermo);
          this.novoTipoTermo = '';
          this.$emit("update:visible", false);
        }
      },
    },
  };
</script>
  